import React, { useEffect } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import Loader from "../../../Components/Common/Loader";
import Error from "../../../Components/Common/Error";
import BreadCrumb from '../../../Components/Common/BreadCrumb'
import ComplianceTable from '../../../Components/ManageCompliance/ComplianceTable'
import { getCertificationList } from '../../../slices/ManageCompliance/thunk';

export default function ManageCompliance() {

    // Get Clients List
    const dispatch = useDispatch();
    const { isLoading, isError, data } = useSelector(state => state.GetComplianceList);

    const refreshClientList = () => {
        dispatch(getCertificationList());
    };

    useEffect(() => {
        dispatch(getCertificationList());
    }, [dispatch]);

    if (isLoading) return <Loader />;
    if (isError) return <Error />;

    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={'Manage Compliance'} pageTitle={"Dashboard"} />

                    <Row>
                        <Col lg={12}>
                            <ComplianceTable data={data} refreshClientList={refreshClientList} />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}
